
import Typography from '@mui/material/Typography';


export const TextDrugDapsone = () => {

return(
<div>
    
<Typography variant="h6" >
<br />


Dapsone is used to treat leprosy and skin infections.

This medication is sometimes prescribed for other uses;
<br /><br />


Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a682128.html

</Typography>

</div>

)
}